import React from "react";
import { portfolioData } from "../data/portfolioData";
import { motion } from "framer-motion";

const Projects = () => {
  const { projects, sections } = portfolioData;

  return (
    <section id="projects" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.projectsTitle}</h2>
        <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project) => (
            <motion.article
              key={project.name}
              whileHover={{
                y: -4,
                boxShadow: "0 10px 24px rgba(79, 70, 229, 0.12)",
                borderColor: "rgba(79, 70, 229, 0.45)",
              }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="rounded-xl border border-slate-200 bg-white/80 p-6"
            >
              <p className="text-xs uppercase tracking-[0.16em] text-indigo-700">{project.tech}</p>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">{project.name}</h3>
              {project.dataset && (
                <p className="mt-3 text-sm text-slate-700">
                  <span className="font-semibold">Dataset:</span> {project.dataset}
                </p>
              )}
              {project.model && (
                <p className="mt-1 text-sm text-slate-700">
                  <span className="font-semibold">Model:</span> {project.model}
                </p>
              )}
              <p className="mt-3 text-sm leading-relaxed text-slate-700">
                {project.description}
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                {project.links?.code && (
                  <a
                    href={project.links.code}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-semibold text-indigo-700 hover:text-indigo-600"
                  >
                    View Code
                  </a>
                )}
                {project.links?.notebook && (
                  <a
                    href={project.links.notebook}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-semibold text-indigo-700 hover:text-indigo-600"
                  >
                    View Notebook
                  </a>
                )}
                {project.links?.live && (
                  <a
                    href={project.links.live}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-semibold text-indigo-700 hover:text-indigo-600"
                  >
                    Live Dashboard
                  </a>
                )}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
